<div class="satisfaction-rate-module">
<div class="title">{{ 'lang.reporting.satisfactionRate' | translate }}</div>
  <div class="overall-rating-statistic row">
    <div class="satisfaction-value col-5">
      <span class="value">{{ getPositiveValue() }}</span>
      <span class="dimension">%</span>
    </div>
    <div class="satisfaction-indicators col-7">
      <div class="row m-l-15">
        <div class="m-r-5" *ngIf="negative>0">
          <div class="rate">{{ getValue(satisfactionRateAnswerCategory.Negative) }}%</div>
          <span [inlineSVG]="getRateSVG(negative)" [onSVGLoaded]="handleSVG" class="satisfaction-indicator-negative"></span>
        </div>
        <div class="m-r-5" *ngIf="neutral>0">
          <div class="rate">{{ getValue(satisfactionRateAnswerCategory.Neutral) }}%</div>
          <span [inlineSVG]="getRateSVG(neutral)" [onSVGLoaded]="handleSVG" class="satisfaction-indicator-neutral"></span>
        </div>
        <div class="m-r-5" *ngIf="positive">
          <div class="rate">{{ getValue(satisfactionRateAnswerCategory.Positive) }}%</div>
          <span [inlineSVG]="getRateSVG(positive)" [onSVGLoaded]="handleSVG" class="satisfaction-indicator-positive"></span>
        </div>
      </div>
    </div>
  </div>
  <div class="satisfaction-description">
    {{ satisfaction.name }}
  </div>
</div>